import React, { useState } from "react";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as RiderOfferActions from "../../store/actions/RiderOfferActions";
import FilterButton from "../../components/Common/FilterButton";
import { FlexContainer } from "../../constants/assets/containers";
import RiderOffersFilterModal from "../../components/RiderOffers/RiderOffersFilterModal";
import RiderOfferCard from "../../components/RiderOffers/RiderOffersCard";

const RiderOffers = ({ riderOffers, activeFilters }) => {
  const [modalState, setModalState] = useState(false);
  const filterFields = ["driver_id", "start_date", "end_date", "is_achieved"];

  const handleClick = (type, id) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  const applyOfferFilters = (offers) => {
    if (riderOffers?.multiplier_offers?.length > 0)
      offers = [...riderOffers.multiplier_offers, ...offers];

    if (offers == undefined) return [];

    return offers?.filter((offer) => {
      const slabs = offers["slabs"];
      if (slabs == undefined) {
        return true;
      }
      const targets = offer["slabs"]["targets"];
      if (activeFilters["is_achieved"]) {
        const res = targets.some((target) => target["state"] == "ACHIEVED");
        return res;
      } else {
        return true;
      }
    });
  };

  return (
    <RiderOffersViewContainer>
      <FlexContainer className="mb-20">
        <h1> Rider Offers </h1>
        <FilterButton
          activeFilters={activeFilters}
          handleClick={() => handleClick("Filter", null)}
        />
        {modalState && (
          <RiderOffersFilterModal
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        )}
      </FlexContainer>
      <RiderOfferCardContainer>
        {renderOffers(applyOfferFilters(riderOffers["offers"]))}
      </RiderOfferCardContainer>
    </RiderOffersViewContainer>
  );
};

const renderOffers = (offers = []) => {
  return offers?.map((offer) => {
    return (
      <RiderOfferCardWrapper>
        <RiderOfferCard data={offer} />
      </RiderOfferCardWrapper>
    );
  });
};

const RiderOfferCardWrapper = styled.div`
  padding: 10px;
  margin: 10px;
`;

const RiderOfferCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-contents: center;
`;

const RiderOffersViewContainer = styled.section`
  & div > div:nth-child(2) {
    margin-bottom: unset;
  }
`;

function mapStateToProps(state) {
  const { RiderOffers } = state;
  return {
    riderOffers: RiderOffers.riderOffers,
    activeFilters: RiderOffers.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRiderOffers: bindActionCreators(
      RiderOfferActions.getRiderOffers,
      dispatch
    ),
    resetState: bindActionCreators(RiderOfferActions.resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiderOffers);
